import { Grid, Typography } from '@mui/material';
import React from 'react';
import {
  getDateUsingFormat,
  WsChip,
  WsChipVariants,
  WsTypography,
  WsTypoVariants,
  WsChipSize,
  WsTypoColors,
} from 'wisestep-base';

import { onRecruiterNameClick } from '../../../../../features/candidateLayout/utils/CandidateHelper';
import WsAvatar from '../../../../../features/teams/components/WsAvatar';
import PersonAvatar from '../../../../../images/Avatar/Person.svg';

export interface NoteTagType {
  label: string;
  variant: WsChipVariants;
  borderColor: string;
}

export interface NoteActivityCardProps {
  avatarSrc?: string;
  userName: string;
  actionText?: string;
  noteText: string;
  timestamp: string;
  recruiterId: string;
  tags?: NoteTagType[];
}

const NoteActivity: React.FC<NoteActivityCardProps> = ({
  avatarSrc = PersonAvatar,
  userName,
  actionText = 'posted a note ',
  noteText,
  timestamp,
  recruiterId,
  tags = [],
}) => {
  const handleUserNameClick = () => onRecruiterNameClick(recruiterId ?? '');
  return (
    <Grid display="flex" flexDirection="column" rowGap={0.5}>
      <Grid display="flex" justifyContent="space-between" alignItems="center">
        <Grid xs={8} item display="flex" alignItems="center" columnGap={1}>
          <WsAvatar src={avatarSrc} />
          <Grid item>
            <Grid item display="flex" alignItems="center" columnGap={0.5}>
              {recruiterId ? (
                <WsTypography
                  onClick={handleUserNameClick}
                  cursor="pointer"
                  color={WsTypoColors.PRIMARY750}
                >
                  {userName}
                </WsTypography>
              ) : (
                <WsTypography>{userName}</WsTypography>
              )}
              <WsTypography variant={WsTypoVariants.BODY2} opacity>
                {actionText}
              </WsTypography>
            </Grid>
          </Grid>
        </Grid>
        <Grid xs={4} display="flex" justifyContent="flex-end">
          <WsTypography variant={WsTypoVariants.BODY2} opacity={true}>
            {getDateUsingFormat(new Date(timestamp).toString(), 'MMM D, YYYY, h:mm A')}
          </WsTypography>
        </Grid>
      </Grid>

      <Grid pl={5} display="flex" flexDirection="column" rowGap={1}>
        <Typography
          fontWeight={500}
          dangerouslySetInnerHTML={{
            __html: noteText ?? '',
          }}
        />
        {tags.length > 0 && (
          <Grid container columnGap={1}>
            {tags.map((tag, index) => (
              <WsChip
                key={index}
                value={tag.label}
                size={WsChipSize.MEDIUM}
                variant={tag.variant}
                borderColor={tag.borderColor}
              />
            ))}
          </Grid>
        )}
      </Grid>
    </Grid>
  );
};

export default NoteActivity;
